<template>
  <v-container>
    <v-card flat color="transparent">
      <DeliveryOrPickUpSwitcher />
      <v-card-title v-once v-text="$dictionary.get('pickup-title')" />
      <v-card-subtitle v-once v-text="$dictionary.get('pickup-subtitle')" />
      <v-card-text>
        <PointSelect v-model="point" />
      </v-card-text>
      <v-card-text ref="actions">
        <Button title="save-pickup-point"
                @click="save()"
                @click.native="$ym.do('pick_up_save')"
        />
        <Button subtitle="clear-pickup-point"
                sub-button
                @click="save(true)"
                @click.native="$ym.do('pick_up_clear_and_save')"
        />
      <!--
      <Button v-if="badOrderTime"
              subtitle="geo-ignore-bad-time"
              sub-button
              @click="save()"
      />
      <Button v-if="fromCheckout"
              subtitle="go-to-checkout-adds"
              sub-button
              to="/checkout"
      />
      <Button v-if="fromShowcase"
              subtitle="go-to-showcase-adds"
              sub-button
              to="/showcase"
      />
      -->
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable no-undef */

import Button from '@/components/Button';
import AlertTimeRange from '@/components/AlertTimeRange';
import DeliveryOrPickUpSwitcher from '@/components/DeliveryOrPickupSwitcher';
import PointSelect from '@/components/PointSelect';

export default {
  name: 'Address',
  components: { PointSelect, DeliveryOrPickUpSwitcher, AlertTimeRange, Button },
  data: () => ({
    point: null,
  }),
  computed: {
    dark() { return this.$store.state.theme.productDark; },
    color() { return this.$store.state.theme.productColor; },
    points() {
      return this.$store.state.data.points;
    },
    fromCheckout() {
      return this.$route.params.from === 'checkout';
    },
    fromShowcase() {
      return this.$store.state.data.point > 0 && !this.fromCheckout;
    },

  },
  watch: {
  },
  mounted() {
    this.point = this.$store.state.data.point;
    if (!this.point) {
      // eslint-disable-next-line prefer-destructuring
      this.point = Object.keys(this.points)[0];
    }
    if (this.$store.state.data.settings.readonly) {
      this.$router.push('/showcase');
    }
  },
  methods: {
    save(clear) {
      if (clear === true) {
        this.point = 0;
      }
      this.$store.commit('data/mode', 'pickup');
      this.$store.commit('data/point', this.point);
      this.$store.commit('data/address', null);
      this.$store.commit('data/sections', this.$content.getFlattened());
      this.$router.push(this.fromCheckout ? '/checkout' : '/showcase');
    }
  },
};
</script>
